<template>
  <!-- Bootstrap 5 modal -->
  <div
    ref="modalEl"
    class="modal fade"
    tabindex="-1"
    aria-labelledby="orderModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 id="orderModalLabel" class="modal-title">
            Orden #{{ activeOrderId }}
          </h5>
          <button
            type="button"
            class="btn-close"
            @click="handleClose"
          />
        </div>

        <div class="modal-body">
          <!-- tu contenido aquí -->
          <p>Detalle de la orden {{ activeOrderId }}</p>
        </div>

        <div class="modal-footer">
          <button class="btn btn-secondary" @click="handleClose">
            Cerrar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { Modal } from 'bootstrap'

export default {
  name: 'OrderModal',

  data() {
    return {
      bsModal: null
    }
  },

  computed: {
    ...mapGetters({
      orderModalVisible: 'modals/ticketUpdate/orderModalVisible',
      activeOrderId:     'modals/ticketUpdate/activeOrderId'
    })
  },

  watch: {
    orderModalVisible(val) {
      val ? this.bsModal.show() : this.bsModal.hide()
    }
  },

  mounted() {
    // Instanciar Bootstrap Modal sobre el elemento del DOM
    this.bsModal = new Modal(this.$refs.modalEl, {
      keyboard: true,
      backdrop: true
    })

    // Sincronizar Vuex cuando el usuario cierra con Esc o backdrop
    this.$refs.modalEl.addEventListener('hidden.bs.modal', () => {
      this.closeOrderModal()
    })
  },

  beforeDestroy() {
    this.bsModal.dispose()
  },

  methods: {
    ...mapActions({
      closeOrderModal: 'modals/ticketUpdate/closeOrderModal'
    }),
    handleClose() {
      this.closeOrderModal()
      // Limpiar query sin recargar
      this.$router.replace({ query: { ...this.$route.query, order_view: undefined } })
    }
  }
}
</script>
